const pdpStickyAdd = document.getElementById('pdp-sticky-add');
const pdpDetails = document.getElementById('details');
const pdpThemeFooter = document.getElementById('shopify-section-footer');

function pdpLightboxHandler(){
  el = this;
  pdpLightboxFrom = el;
  var items = document.querySelectorAll(el.dataset.lightboxItems);
  if(items.length){ // multiple items
    var itemsArr = Array.prototype.slice.call(items);
    var startSlide = itemsArr.indexOf(el.parentNode) || 0;
    if(el.dataset.lightboxIndex){
      startSlide = el.dataset.lightboxIndex;
    }
    pdpLightboxSwiperOptions['initialSlide'] = startSlide;
    var contentHTML = '<div id="swiper-lightbox" class="swiper-container overflow-hidden"><div class="swiper-wrapper">';
    items.forEach(function(item){
      if(item.dataset.mediaType == 'image'){
        var itemImage = item.querySelector('img');
        var itemContent = '<img class="pdp-lightbox-img swiper-lazy" data-srcset="'+(itemImage.srcset ? itemImage.srcset : itemImage.dataset.srcset)+'" sizes="100vw" alt="'+itemImage.alt+'">';
      } else {
        var itemImageContainer = item.querySelector('.AspectRatio') || item;
        if(itemImageContainer.dataset.lightboxSrcset){
          var itemContent = '<img class="'+(itemImageContainer.dataset.lightboxWide == 'true' ? 'AR--wide':'')+'" srcset="'+itemImageContainer.dataset.lightboxSrcset+'">';
        } else {
          var itemContent = (itemImageContainer.innerHTML).replace('pdp-gallery-video','pdp-lightbox-video');
        }
        itemContent = itemContent.replace('<video','<video onclick="{this.currentTime > 0 && !this.paused ? this.pause() : this.play();}"');
      }
      var aspectRatio = item.dataset.ar || '';
      var itemHTML = `<div class="swiper-slide"><div class="pdp-lightbox-item AspectRatio${aspectRatio == '' ? ' AspectRatio--square' : ''}${itemContent.indexOf('AR--wide') != -1 ? ' AR--wide':''}" style="--aspect-ratio:${aspectRatio}">${itemContent}</div></div>`;
      contentHTML += itemHTML;
    });
    contentHTML += '</div><div class="swiper-controls"><button class="swiper-button-prev hidden-tablet-wide"><span class="swiper-slider__arrow swiper-slider__arrow--prev"></span></button><button class="swiper-button-next hidden-tablet-wide"><span class="swiper-slider__arrow swiper-slider__arrow--next"></span></button></div><div class="pdp-swiper-pagination-lightbox swiper-pagination"></div></div>';
    pdpLightboxItems.innerHTML = contentHTML;
    pdpLightbox.classList.remove('hide');
    var lightboxSwiper = new Swiper('#swiper-lightbox',pdpLightboxSwiperOptions);
  } else { // single image or video
    var itemImage = el.querySelector('img');
    var itemVideo = el.dataset.video;
    if(itemVideo){
      if(itemVideo.indexOf('vimeo') != -1){
        var videoHTML = '<div id="pdp-lightbox-video" class="vimeo-video" data-vimeo-url="'+itemVideo+'" data-vimeo-autoplay="true" data-vimeo-title="false" data-vimeo-portrait="false" data-vimeo-byline="false" data-vimeo-responsive="true"></div>';
        pdpLightboxItems.innerHTML = videoHTML;
        hwAddVimeoAPI('pdp-lightbox-video');
      } else {
        var videoHTML = '<div id="pdp-lightbox-video"><video src="'+itemVideo+'" type="" autoplay playsinline controls></video></div>';
        pdpLightboxItems.innerHTML = videoHTML;
      }
    } else if(itemImage){
      pdpLightboxItems.innerHTML = '<div class="pdp-lightbox-item AspectRatio AspectRatio--square"><img srcset="'+(itemImage.srcset ? itemImage.srcset : itemImage.src)+'" alt="'+itemImage.alt+'"></div>';
    }
    pdpLightbox.classList.remove('hide');
  }
  hwTrapFocus(pdpLightbox);
}

function pdpLightboxInit(){
  pdpLightboxLaunchers = document.querySelectorAll('.pdp-lightbox-launch');
  pdpLightboxLaunchers.forEach(function(el){
    el.removeEventListener('click',pdpLightboxHandler);
    el.addEventListener('click',pdpLightboxHandler);
  });
}

function initPDP(){

  // Fetch extra product data
  fetch(`${pdpProduct.domain}${pdpProduct.path}?view=pdp-data`, {
  credentials: 'same-origin',method: "GET",headers: {"Content-type": "text/html; charset=UTF-8"}
  }).then((response) => response.text()).then((response) => {
    var pdpData = JSON.parse(response);
    pdpVariants = Object.keys(pdpData.variants).map((k) => pdpData.variants[k]);
    pdpMaterialData = pdpData.materials;
    pdpSelectedVariant = pdpData.variants[pdpInitVariantID];
    updateOptions();
    updateLeadTime();
  });

  // Open content drawer by hash
  if (window.location.hash) {
    var hash = window.location.hash.substring(1);
    var details = document.getElementById(hash);
    if(details){
      var headerEl = bpMobile.matches ? document.querySelector('.Header__top-row') : document.querySelector('.MainNav__bottomMenu');
      var scrollTo = details.offsetTop - headerEl.offsetHeight;
      details.open = true;
      window.scroll({top: scrollTo});
    }
  }

  // Init Events
  document.body.addEventListener('change', function(e) {
    if(e.srcElement.classList.contains('pdp-option__input')){
      updateVariant(e.srcElement);
      updateSelectedOption(e.target);
    }
  });
  ['scroll','resize'].forEach(evt => window.addEventListener(evt,pdpSticky,false));
  pdpLightboxInit();
  pdpLightboxClose.addEventListener('click',function(){
    pdpLightboxItems.innerHTML = '';
    pdpLightbox.classList.add('hide');
    hwCancelTrapFocus(pdpLightbox);
    if(pdpLightboxFrom !== null){
      pdpLightboxFrom.focus();
      pdpLightboxFrom = null;
    }
  });
  var popupCloseLinks = document.querySelectorAll('.popup-link-close')
  popupCloseLinks.forEach(function(el){
    el.addEventListener('click', function(e) {
      if(e.target.classList.contains('popup-link') || e.target.classList.contains('popup-close')){
        e.preventDefault();
        var popupEl = document.getElementById(e.target.dataset.popup);
        if(popupEl){
          popupEl.classList.toggle("show");
          el.setAttribute('aria-expanded',`${popupEl.classList.contains('show')}`);
        }
      }
    });
  });
  var popupHoverLinks = document.querySelectorAll('.supports-hover .popup-link--hover');
  popupHoverLinks.forEach(function(el){
    var popupEl = document.getElementById(el.dataset.popup);
    if(popupEl){
      el.addEventListener('mouseover',function(){
        popupEl.classList.add("show");
        el.setAttribute('aria-expanded','true');
      });
      el.addEventListener('mouseleave',function(){
        popupEl.classList.remove("show");
        el.setAttribute('aria-expanded','false');
      });
    }
  });

  // Measurement Popup
  var pdpMeasurePopupTriggers = document.querySelectorAll('.measure-popup-trigger');
  if(pdpMeasurePopupTriggers.length){
    pdpMeasurePopupTriggers.forEach((btn) => {
      btn.addEventListener('click',(triggerEvt) => {
        triggerEvt.preventDefault();
        fetch(`${pdpProduct.domain}${pdpProduct.path}?view=ajax.measure`).then((response) => response.text()).then((text) => {
          var html = hwDOMParser.parseFromString(text,'text/html');
          var popup = html.getElementById('pdp-popup');
          document.body.append(popup);
          var popupClose = document.getElementById('pdp-popup-close');
          popupClose.focus();
          var popupSwiper = new Swiper('#measure-popup-swiper',{
            pagination:{el:'#measure-popup-swiper .swiper-pagination',clickable: true}
          });
          popupClose.addEventListener('click',(closeEvt) => {
            popup.remove();
            triggerEvt.target.focus();
          });
        });
      });
    });
  }
}

window.addEventListener('DOMContentLoaded',function(){
  initPDP();
});

function updateLeadTime(){
  pdpLeadTimeEls.forEach(function(el){
    var colorParent = el.closest('.pdp-option__colors');
    if(colorParent){
      if(colorParent.querySelector('.pdp-option__input:checked')){
        el.textContent = pdpSelectedVariant.lead_time_msg;
      } else {
        el.textContent = '';
      }
    } else {
      el.textContent = pdpSelectedVariant.lead_time_msg;
    }
    if(pdpSelectedVariant.out_of_stock){
      el.classList.add('color--dark-red');
    } else {
      el.classList.remove('color--dark-red');
    }
  });
}

function updateAddBtns(){
  if(!pdpSelectedVariant.available){
    pdpAddBtns.forEach((btn) => {
      btn.disabled = true;
    });
  } else {
    pdpAddBtns.forEach((btn) => {
      btn.removeAttribute('disabled');
    });
  }
  if(pdpWishlistBtn){
    pdpWishlistBtn.dataset.variant = pdpSelectedVariant.id;
    if(customElements.get('wishlist-button')){
      pdpWishlistBtn.updateData();
    }
  }
}

const pdpVariantSKU = document.getElementById('pdp-variant-sku');

function updateVariant(input){
  var selectedOptions = Array.from(pdpOptionInputs).filter(el => el.checked).map(el => el.value);
  var variantSet = pdpVariants;
  for (var x = 0; x < pdpOptions.length; x++) {
    variantSet = variantSet.filter(v => v.options[x] == selectedOptions[x]);
  }
  pdpSelectedVariant = variantSet[0];
  if(!pdpSelectedVariant){
    var optVars = pdpVariants.filter((variant) => variant.option1 == selectedOptions[0]);
    if(selectedOptions.length == 3 && input.dataset.optionPosition == "2"){
      optVars = optVars.filter((variant) => variant.option2 == selectedOptions[1]);
    }
    pdpSelectedVariant = optVars[0];
  }
  if(pdpSelectedVariant){
    updateImages();
    updatePrice(pdpSelectedVariant);
    updateLeadTime();
    updateOptions();
    updateAddBtns();
    pdpVariantSKU.textContent = pdpSelectedVariant.sku || '';
    pdpVariantIDInput.value = pdpSelectedVariant.id;
    window.history.replaceState({ }, '', `${pdpProduct.path}?variant=${pdpSelectedVariant.id}`);
  }
}

function updateOptions(){
  if(pdpSelectedVariant.option2 !== null){
    var option1Vars = pdpVariants.filter((variant) => variant.option1 == pdpSelectedVariant.option1);
    var option2Vals = option1Vars.map((variant) => variant.option2);
    var option2Els = document.querySelectorAll('.pdp-option-2-value');
    showHideVals(option2Els,option2Vals,pdpSelectedVariant.option2);
    if(pdpSelectedVariant.option3 !== null){
      var option2Vars = option1Vars.filter((variant) => variant.option2 == pdpSelectedVariant.option2);
      var option3Vals = option2Vars.map((variant) => variant.option3);
      var option3Els = document.querySelectorAll('.pdp-option-3-value');
      showHideVals(option3Els,option3Vals,pdpSelectedVariant.option3);
    }
  }
}

function showHideVals(els,vals,selected){
  els.forEach(function(el){
    var inputEl = el.querySelector('input');
    if(vals.includes(el.dataset.optionValue)){
      el.classList.remove('hide');
      if(el.dataset.optionValue == selected){
        inputEl.checked = true;
        updateSelectedOption(inputEl);
      } else {
        inputEl.checked = false;
      }
    } else {
      el.classList.add('hide');
      inputEl.checked = false;
    }
  });
}

function formatPrice(price){
  price = priceFormatter.format(price / 100);
  return `${price}` + (pdpProduct.currency != 'USD' ? `${' ' + pdpProduct.currency}` : '');
}

function updateAffirm(price) {
  if(pdpAffirm && typeof affirm != 'undefined'){
    var qty = pdpQtyInput.value;
    pdpAffirm.setAttribute('data-amount', price * qty);
    affirm.ui.refresh();
  }
}

function updatePrice(variant){
  var comparePrice = null;
  var price = variant.price;
  var pricesHTML = '';
  if(variant.compare_at_price > variant.price){
    comparePrice = variant.compare_at_price;
  }
  var priceHTML = `<span class="pdp-price__price">${formatPrice(price)}</span>`;
  if(comparePrice !== null){
    var compareHTML = `<span class="pdp-price__compare founders-md-font strikethrough" aria-label="Original price ${formatPrice(comparePrice)}">${formatPrice(comparePrice)}</span>`;
    var percentBadge = '';
    var percent = Math.floor((1 - (price / comparePrice)).toFixed(2) * 100);
    percentBadge = `<span class="savings-badge display-inline-block founders-md-font relative">${percent}% OFF</span>`;
    var salePriceHTML = ` <span class="text-red">${priceHTML}${percentBadge}</span>`;
    pricesHTML = compareHTML + salePriceHTML;
  } else {
    pricesHTML = priceHTML;
  }
  pdpPrices.forEach(function(el){
    el.innerHTML = pricesHTML;
  });
  pdpSelectedVariantPrice = price;
  updateAffirm(price);
}

function updateSelectedOption(el){
  var parent = el.closest('.pdp-option');
  var newValue = el.value.indexOf('(') !== -1 ? el.value.split('(')[0] : el.value;
  var option = el.getAttribute('name');
  parent.querySelectorAll(`.pdp-selected[data-option="${option}"]`).forEach((elem) => {
    elem.textContent = newValue;
  });
}

function updateImages(){
  var newSrc = pdpSelectedVariant.featured_image ? pdpSelectedVariant.featured_image.src : pdpFeaturedImage;
  var newSrcset = newSrc + '&width=400 400w,' + newSrc + '&width=515 515w,' + newSrc + '&width=800 800w,' + newSrc + '&width=1030 1030w,' + newSrc + '&width=1600 1600w';
  pdpVariantImg.srcset = newSrcset;
  var swiperMain = pdpGallerySwiper.swiper;
  var swiperOptions = null;
  if(swiperMain){
    swiperOptions = swiperMain.passedParams;
    swiperMain.destroy();
  }

  var oldImgs = document.querySelectorAll('#swiper-pdp-gallery .pdp-gallery-variant-set');
  oldImgs.forEach(function(el){
    el.remove();
  });
  var newImgs = pdpSelectedVariant.image_set;
  var gallery = document.querySelector('.pdp-gallery__items');
  var lastAdded = gallery.querySelector('.pdp-gallery__item');
  var videoIndex = (pdpProduct.videoIndex) ? pdpProduct.videoIndex - 1 : null;
  var videoEl = gallery.querySelector('.pdp-gallery-global--video');

  for(var i = 0; i < newImgs.length; i++){
    var newSlide = document.createElement('div');
    newSlide.className = 'swiper-slide pdp-gallery__item pdp-gallery-variant-set';
    newSlide.innerHTML = newImgs[i];
    if(videoEl && i == videoIndex){
      lastAdded = videoEl;
    }
    lastAdded.insertAdjacentElement('afterend',newSlide);
    lastAdded = newSlide;
  }
  pdpGallerySwiper.classList.remove('fixed','fixed--top');
  pdpGallerySwiper.removeAttribute('style');
  if(swiperOptions != null){
    pdpGallerySwiperInstance = new Swiper(pdpGallerySwiper,swiperOptions);
  }
  pdpLightboxInit();
  pdpSticky();
}

function decreaseQuantity() {
  if (pdpQtyInput.value > 1) {
    pdpQtyInput.value--;
    updateAffirm(pdpSelectedVariantPrice);
    if(typeof qvUpdateATCbtn == 'function'){
      qvUpdateATCbtn();
    }
  }
}

function increaseQuantity() {
  if (pdpQtyInput.value < 100) {
    pdpQtyInput.value++;
    updateAffirm(pdpSelectedVariantPrice);
    if(typeof qvUpdateATCbtn == 'function'){
      qvUpdateATCbtn();
    }
  }
}

function pdpExecuteAdd(addObj,thisBtn,addCallback){
  fetch(`${pdpProduct.domain}${window.routes.cartAddUrl}.js`, {
    body: JSON.stringify(addObj),
    credentials: 'same-origin',
    method: 'POST',
    headers: {'Content-Type': 'application/json','X-Requested-With': 'XMLHttpRequest'}
  }).then(function(response) {
    pdpEl.dispatchEvent(new CustomEvent('theme:loading:end'));
    if(response.ok) {
      response.json().then(function(content) {
        var qty = parseInt(addObj.items[0].quantity);
        if(window.theme.addSuccessPopup && !addCallback){
          hwGetATCSuccess(content.items[0].key,pdpSelectedVariant,qty,pdpEl);
        } else if(addCallback) {
          addCallback(content);
        } else {
          pdpEl.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: pdpSelectedVariant,
              quantity: qty
            }
          }));
        }
        document.getElementById('theme-aria-live').textContent = `Your item${addObj.items.length == 1 ? ' was' : 's were'} successfully added to cart.`;
      });
    } else {
      response.json().then(function(content) {
        var errorEl = document.createElement('div');
        errorEl.className = 'Alert Alert--error';
        errorEl.setAttribute('aria-live','polite');
        thisBtn.insertAdjacentElement('afterend',errorEl);
        errorEl.innerHTML = content['description'];
        setTimeout(function() {
          errorEl.remove();
        }, 2500);
      });
    }
    thisBtn.removeAttribute('disabled');
    const pdpMobileStickyAdd = document.getElementById('pdp-sticky-add');
    if(pdpMobileStickyAdd){
      pdpMobileStickyAdd.classList.remove('fixed');
      thisBtn.textContent = thisBtn.dataset.atc;
    }
  });
}

function pdpAddItemProperties(variant){
  var properties = {};
  if(variant.lead_time_type !== '' && variant.order_lead_time_msg !== ''){
    properties[`${variant.lead_time_type}`] = variant.order_lead_time_msg;
  }
  if(variant.restock_date !== ''){
    properties["Restock Date"] = variant.restock_date;
  }
  return properties;
}

function pdpAddToCart(e){
  e.preventDefault();
  var thisBtn = e.target;
  thisBtn.setAttribute('disabled', 'disabled');
  if(thisBtn.closest('#pdp-sticky-add')){
    thisBtn.textContent = 'Updating...';
  }

  var itemProperties = pdpAddItemProperties(pdpSelectedVariant);
  var addObj = {
    items:[
      {id: pdpSelectedVariant.id, quantity: parseInt(pdpQtyInput.value), properties: itemProperties}
    ]
  };
  var selectedAddOns = document.querySelectorAll('.addon-card__checkbox:checked');
  if(selectedAddOns.length){
    pdpAddOnsATC(selectedAddOns,addObj,thisBtn);
  } else {
    pdpExecuteAdd(addObj,thisBtn);
  }
}

function pdpSticky(e){
  if(bpMobile.matches){
    pdpStickyMobile(e);
  } else {
    pdpStickyTablet();
  }
}

function pdpStickyMobile(e){
  if(pdpOptionsEl){
    if(pdpOptionsEl.offsetHeight > 376){
      var galleryBottom = pdpGallery.offsetTop + (pdpGallery.offsetHeight / 2) - pdpHeaderEl.offsetHeight;
      var optionsBottom = pdpOptionsEl.offsetTop + pdpOptionsEl.offsetHeight - pdpHeaderEl.offsetHeight - 376;
      if(window.scrollY > galleryBottom && window.scrollY < optionsBottom){
        pdpGallery.style.height = pdpGallery.offsetWidth + 'px'; // set it to the width because the image is square
        pdpGallery.classList.add('fixed');
      } else {
        pdpGallery.classList.remove('fixed');
      }
    }
  }
  // Sticky Add Bar
  var detailsTop = pdpDetails.offsetTop;
  if(window.scrollY >= (detailsTop - pdpHeaderEl.offsetHeight) && window.scrollY < (pdpThemeFooter.offsetTop - pdpHeaderEl.offsetHeight)){
    pdpStickyAdd.classList.add('fixed');
  } else {
    pdpStickyAdd.classList.remove('fixed');
  }
}

function pdpStickyTablet(){
  pdpGallery.removeAttribute('style');
  var viewportBottom = window.scrollY + window.innerHeight;
  if(pdpMainContent.offsetHeight > pdpGallerySwiper.offsetHeight){ // right column is longer
    var stickyEl = pdpGallerySwiper;
    var staticEl = pdpMainContent;
  } else { // left column is longer
    var stickyEl = pdpMainContent;
    var staticEl = pdpGallerySwiper;
  }

  var stickyElParent = stickyEl.parentNode;
  var stickyElBottom = stickyElParent.offsetTop + stickyEl.offsetHeight;
  var contentViewportHeight = window.innerHeight - pdpEl.offsetTop;
  var shortStickyTop = 0;

  staticEl.classList.remove('fixed','bottom');
  staticEl.removeAttribute('style');

  // Fixed state
  if(viewportBottom > stickyElBottom || contentViewportHeight > stickyEl.offsetHeight){
    stickyEl.classList.add('fixed');
    var style = 'width:' + stickyElParent.clientWidth + 'px;left: ' + stickyElParent.offsetLeft + 'px;';
    var topStyle = 'top:' + stickyElParent.offsetTop + 'px;'
    shortStickyTop = stickyElParent.offsetTop;
    if(contentViewportHeight > stickyEl.offsetHeight){
      stickyEl.classList.add('fixed--top');
      style += topStyle;
    } else {
      stickyEl.classList.remove('fixed--top');
      style.replace(topStyle,'');
    }
    stickyEl.style.cssText = style;
  } else {
    stickyEl.classList.remove('fixed');
    stickyEl.removeAttribute('style');
  }

  // Bottom state
  if(contentViewportHeight > stickyEl.offsetHeight){
    if(window.scrollY >= (pdpEl.offsetTop + (staticEl.offsetHeight - stickyEl.offsetHeight - shortStickyTop))){
      stickyEl.classList.add('bottom');
    } else {
      stickyEl.classList.remove('bottom');
    }
  } else {
    if(viewportBottom > (stickyElParent.offsetTop + stickyElParent.offsetHeight)){
      stickyEl.classList.add('bottom');
    } else {
      stickyEl.classList.remove('bottom');
    }
  }
}

function pdpShowPopover(target) {
  if(bpTablet.matches){
    var optionName = target.dataset.optionName;
    if(pdpDisabledSwatches != null){
      if(pdpDisabledSwatches.indexOf(optionName) != -1){
        return;
      }
    }
    var colorTitle = target.querySelector('input').value;
    var colorData = pdpMaterialData[colorTitle];
    if(colorData){
      if(colorTitle.indexOf('(') !== -1){
        colorTitle = colorTitle.split('(')[0];
      }
      var targetContainer = target.closest('.pdp-option__values');
      var popoverContainer = document.createElement('div');
      popoverContainer.id = 'pdp-color-popover';
      targetContainer.appendChild(popoverContainer);
      pdpPopoverTarget = target;
      var popover = "";
      var swatchUrl = target.querySelector('img').src;
      var characteristics = colorData.characteristics.split('|');
      var desc = colorData.description || "";
      popover += "<div id='pdp-color-popover-arrow'></div>";
      popover += "<div class='color-popover__image swatch overflow-hidden'>";
      popover += "<img class='full-width' src='" + swatchUrl + "' alt='" + colorTitle + "'>";
      popover += "</div><div class='color-popover__text relative overflow-hidden'>";
      popover += "<p class='color-popover__title'><span class='founders-md-font'>" + colorTitle + "</span></p>";
      popover += "<p class='color-popover__desc'>" + desc + "</p>";
      popover += "<p class='color-popover__characteristics Flex Flex--center-align flex-wrap"+(characteristics.length > 2 ? " Flex--space-between":"")+"'>";
      characteristics.forEach(function(characteristic) {
        popover += "<span class='color-popover__characteristic Flex Flex--center-align'>";
        switch (characteristic) {
          case "Durable":
            popover += "<svg aria-hidden='true' viewBox='0 0 160 160'><defs><style>.cls-1{fill:none;stroke:#001d34;stroke-miterlimit:10;stroke-width:2.5px;}</style></defs><path class='cls-1' d='M155.05,80A75.05,75.05,0,1,1,80.16,5,75,75,0,0,1,155.05,80Z'/><path class='cls-1' d='M85.5,67a21.26,21.26,0,0,1,2.75,2.32h0a20.48,20.48,0,0,1,0,29L70.39,116.16a20.46,20.46,0,0,1-28.95,0h0a20.48,20.48,0,0,1,0-28.95L58.5,70.15'/><path class='cls-1' d='M60.22,81.14,48.65,92.71a11.47,11.47,0,0,0,0,16.24h0a11.49,11.49,0,0,0,16.25,0l2.54-2.54,4-4L81,92.81a11.49,11.49,0,0,0,0-16.25h0a11.56,11.56,0,0,0-1.87-1.51'/><path class='cls-1' d='M86.47,42.18l.62-.62a20.46,20.46,0,0,1,29,0h0a20.46,20.46,0,0,1,0,29L99,87.57'/><path class='cls-1' d='M72,90.68a20.65,20.65,0,0,1-2.75-2.31h0a20.47,20.47,0,0,1,0-29L82.49,46.16'/><path class='cls-1' d='M78.32,82.68a11.63,11.63,0,0,1-1.87-1.52h0a11.49,11.49,0,0,1,0-16.25L92.59,48.77a11.49,11.49,0,0,1,16.25,0h0a11.5,11.5,0,0,1,0,16.25L97.27,76.58'/></svg>";
            break;
          case "Stain Resistant":
            popover += "<svg aria-hidden='true' viewBox='0 0 160 160'><defs><style>.cls-1{fill:none;stroke:#001d34;stroke-miterlimit:10;stroke-width:2.5px;}</style></defs><path class='cls-1' d='M155.05,80A75.05,75.05,0,1,1,80.16,5,75,75,0,0,1,155.05,80Z'/><path class='cls-1' d='M63,55V46.4a6.32,6.32,0,0,1,7.39-6.65,6.47,6.47,0,0,1,5.31,7.43l-2,9.23-.62,2.87'/><path class='cls-1' d='M64.1,112.1A9,9,0,1,0,81.81,115l2-9.45a5.19,5.19,0,0,1,6.58-3.89c2.14.64,4.67,1.39,7.09,2.07'/><path class='cls-1' d='M105.3,105.68a7.23,7.23,0,0,0,8.32-6c.59-3.54-1.39-7.31-4.82-8l-5.7-1.38-1.69-.43'/><path class='cls-1' d='M115.62,64.19a6.88,6.88,0,1,1-2.25,13.57l-9.54-1'/><path class='cls-1' d='M98,55.16a6.81,6.81,0,1,0-13.44-2.23l-.22,1-.27,1.42'/><path class='cls-1' d='M55.62,63.18l-4-.66A13.8,13.8,0,0,0,35.79,73a13.52,13.52,0,0,0,11,16.16l.36.07'/><path class='cls-1' d='M82.48,61.22c-.87,2.32-3.12,4.22-5.71,3.66a4.8,4.8,0,0,1-3.66-5.72'/><path class='cls-1' d='M98,54.89c-.12.91-.46,2.6-.87,4.48a6.29,6.29,0,0,0,8.24,7.32l.1,0,5.43-2.09a7.22,7.22,0,0,1,4.91-.33'/><path class='cls-1' d='M104.29,76.81A6.71,6.71,0,0,0,101.72,90'/><circle class='cls-1' cx='103.46' cy='38.4' r='3.71'/><circle class='cls-1' cx='42.49' cy='105.03' r='7.58'/><circle class='cls-1' cx='129.17' cy='77.95' r='3.71'/><line class='cls-1' x1='27.49' y1='26.57' x2='132.55' y2='133.49'/><path class='cls-1' d='M61.73,60.23a5.74,5.74,0,0,1-6,3l-.14,0'/><path class='cls-1' d='M65.62,105.18l.16-.89.69-4.28a7.69,7.69,0,0,0-6.37-8.82l-1.89-.27'/><line class='cls-1' x1='58.3' y1='90.94' x2='46.96' y2='89.17'/></svg>";
            break;
          case "Textured":
            popover += "<svg aria-hidden='true' viewBox='0 0 160 160'><defs><style>.cls-1{fill:none;stroke:#002a3a;stroke-miterlimit:10;stroke-width:2.5px;}.cls-2{fill:#fff;}</style></defs><polyline class='cls-1' points='112.3 93.86 116.87 89.3 108.95 81.38'/><line class='cls-1' x1='107.74' y1='98.43' x2='112.3' y2='93.86'/><polyline class='cls-1' points='81.55 108.78 89.47 116.7 98.6 107.57 107.74 116.7 116.87 107.57 107.74 98.43'/><polyline class='cls-1' points='63.31 108.78 71.22 116.7 80.36 107.57 89.49 116.7'/><polyline class='cls-1' points='116.87 71.03 107.74 61.89 116.87 52.76 107.74 43.62 98.6 52.76 89.47 43.62 80.33 52.76 71.2 43.62 62.06 52.76 52.93 43.62 43.79 52.76 52.93 61.89 43.79 71.03 52.93 80.16 43.79 89.3 52.93 98.43 43.79 107.57 52.93 116.7 62.06 107.57 71.2 116.7'/><polyline class='cls-1' points='107.74 61.89 116.87 71.03 107.74 80.16 116.87 89.3 116.55 89.62'/><line class='cls-1' x1='80.33' y1='52.76' x2='80.33' y2='107.57'/><line class='cls-1' x1='98.6' y1='52.76' x2='98.6' y2='107.57'/><line class='cls-1' x1='62.06' y1='52.76' x2='62.06' y2='107.57'/><line class='cls-1' x1='51.08' y1='80.16' x2='108.13' y2='80.16'/><line class='cls-1' x1='52.93' y1='61.89' x2='107.74' y2='61.89'/><line class='cls-1' x1='52.93' y1='98.43' x2='107.74' y2='98.43'/><path class='cls-1' d='M155.05,80A75.05,75.05,0,1,1,80.16,5,75,75,0,0,1,155.05,80Z'/><rect class='cls-2' x='110.32' y='101.15' width='4.55' height='4.55' transform='translate(106.11 -49.32) rotate(45)'/></svg>";
            break;
          case "Greenguard Certified":
            popover += "<svg aria-hidden='true' viewBox='0 0 160 160'><defs><style>.cls-1{fill:none;stroke:#002a3a;stroke-miterlimit:10;stroke-width:2.5px;}</style></defs><polyline class='cls-1' points='80 53.83 116.27 53.83 116.27 73.61 80 53.96 43.73 73.61 43.73 53.83 53.87 53.83 53.87 43.74 63.96 43.74 63.96 55.03'/><line class='cls-1' x1='43.73' y1='115.03' x2='43.73' y2='82.53'/><line class='cls-1' x1='116.27' y1='82.53' x2='116.27' y2='115.03'/><polyline class='cls-1' points='87.35 114.86 87.35 83.92 98.27 83.92 98.27 114.86'/><rect class='cls-1' x='60.73' y='83.92' width='10.92' height='10.77'/><path class='cls-1' d='M155,80A75,75,0,1,1,80.16,5,75,75,0,0,1,155,80Z'/></svg>";
            break;
        }
        popover += characteristic + "</span>";
      });
      popover += "</p>";
      if(colorData.contents != ''){
        popover += "<p class='color-popover__contents'><span class='founders-md-font'>Contents:</span>&nbsp;&nbsp;" + colorData.contents + "</p>";
      }
      popover += "</div>";
      popoverContainer.innerHTML = popover;
      pdpPositionPopover(popoverContainer);
    }
  }
}

function pdpPositionPopover(popoverContainer){
  var colorLegend = pdpPopoverTarget.closest('.pdp-option__colors').querySelector('.pdp-option__legend');
  popoverContainer.style.top = (pdpPopoverTarget.offsetTop - 20 - (colorLegend ? colorLegend.offsetHeight : 0) ) + "px";
  var arrow = document.getElementById('pdp-color-popover-arrow');
  var arrowLeft = pdpPopoverTarget.offsetLeft + (pdpPopoverTarget.offsetWidth / 2) - 3;
  arrow.style.left = arrowLeft + "px";
}

function pdpHidePopover() {
  var popover = document.getElementById('pdp-color-popover');
  if(popover){
    popover.remove();
  }
}